import React, { useContext, useRef } from 'react';
import PopupUploadFile, { UploadFilePopupHandle } from '../../components/popupUploadFile/popupUploadFile';
import FilieraContext from '../../contexts/filieraContext';
import PopupDocumentAttachment, { DocumentAttachmentPopupHandle } from '../../components/popupDocumentAttachment/popupDocumentAttachment';
import { apiConfiguration } from '../../apiConfig';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Editing,
  Lookup,
  Toolbar,
  Item,
  Button as GridButton
} from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';

import { incubatoiDataSource } from '../../datasources/incubatoiDataSource';
import { dataGridErrorHandling } from '../../utils/errorHandling';
import { macelliDataSource } from '../../datasources/macelliDataSource';
import { mangimificiDataSource } from '../../datasources/mangimificiDataSource';
import PopupDocumento, { DocumentoPopupHandle } from '../../components/popupDocumento/popupDocumento';
import { documentiDataSource } from '../../datasources/documentiDataSource';
import { CicloDTO } from '../../data';
import { DocumentiMangimeDataSource } from '../../datasources/documentiMangimeDataSource';

type Props = {
  ciclo: CicloDTO,
  readonly?: boolean
};

export default function DocumentiMangimeTable(params: Props) {
  const uploadRef = useRef<UploadFilePopupHandle>(null);
  const pdfViewerRef = useRef<DocumentAttachmentPopupHandle>(null);
  const documentoRef = useRef<DocumentoPopupHandle>(null);
  const gridRef = useRef<DataGrid>(null);
  const { currentFiliera } = useContext(FilieraContext);

  function openUploadFilePopup(e: any) {
    const uploadUrl: string = apiConfiguration.basePath + "/Filiere/" + currentFiliera.Id + "/Cicli/" + e.row.data.idCiclo + "/Documenti/" + e.row.data.id + "/File";

    uploadRef.current?.show(currentFiliera.Id, e.row.data.idCiclo, e.row.data.id, uploadUrl);
  }

  function HasAttachment(e: any) {
    return e.row.data.idArxivar && e.row.data.idArxivar !== 0;
  }

  function ShowAttachment(e: any) {
    pdfViewerRef.current?.show(currentFiliera.Id, Number(params.ciclo.id), e.row.data.id);
  }

  function new_click(e: any) {
    documentoRef.current?.new();
  }

  function edit_click(e: any) {
    documentoRef.current?.edit(e.row.data.id);
  }

  function refreshGrid() {
    gridRef.current?.instance.refresh();
  }

  return (
    <React.Fragment>
      <DataGrid
        ref={gridRef}
        key="Mangime"
        className={'dx-card wide-card'}
        dataSource={DocumentiMangimeDataSource(Number(currentFiliera.Id), Number(params.ciclo.id))}
        showBorders={false}
        focusedRowEnabled={true}
        errorRowEnabled={false}
        defaultFocusedRowIndex={0}
        defaultSelectionFilter=""
        columnAutoWidth={true}
        columnHidingEnabled={true}
        onDataErrorOccurred={dataGridErrorHandling}
        // onInitNewRow={dataGridInitNewRow}
        onRowUpdating={function (e) {
          e.newData = Object.assign({}, e.oldData, e.newData);
        }}
      >
        <Editing allowUpdating={true} allowAdding={true} allowDeleting={true}>
        </Editing>
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector={true} showInfo={true} />
        <FilterRow visible={true} />

        <Column type="buttons" alignment='left'>
          <GridButton name="edit" onClick={edit_click} />
          <GridButton name="delete" disabled={params.readonly} />
          <GridButton hint="Upload documento" icon="upload" onClick={openUploadFilePopup} disabled={params.readonly} />
          <GridButton hint="Visualizza documento" icon="doc" visible={HasAttachment} onClick={ShowAttachment} />
          {/* <Button hint="Dettagli Documento" icon="search" onClick={openDettagli} /> */}
        </Column>
        <Column dataField={'id'} width={90} hidingPriority={2} allowEditing={false} visible={false} />
        <Column dataField={'kgConsegnati'} caption={'Kg consegnati'} dataType='number' />
        <Column dataField={'numeroDocumento'} caption={'Numero'} hidingPriority={8} />
        <Column dataField={'dataDocumento'} caption={'Data'} hidingPriority={2} />
        <Column dataField={'dataOperazione'} caption={'Data consegna'} hidingPriority={6} />
        <Column dataField={'tipiMangime'} caption={'Tipi mangime'} hidingPriority={4} />
        <Column dataField={'idAnagrafeMittente'} caption={'Magimificio'} hidingPriority={3}>
          <Lookup dataSource={mangimificiDataSource} valueExpr="id" displayExpr="ragioneSociale"  />
        </Column>
        <Column dataField={'note'} caption={'Note'} hidingPriority={1} />

        <Toolbar>
          <Item location="after">
            <Button
              icon='refresh'
              onClick={refreshGrid}
            />
            <Button
              icon='add'
              onClick={new_click}
              disabled={params.readonly}
            />
          </Item>
        </Toolbar>
      </DataGrid>

      <PopupDocumentAttachment ref={pdfViewerRef} />

      <PopupUploadFile ref={uploadRef} onUploadCompleted={refreshGrid} allowedFileExtensions={[".pdf"]}></PopupUploadFile>
      <PopupDocumento ref={documentoRef} ciclo={params.ciclo} tipoDocumento={"Mangime"} onChange={refreshGrid} readonly={params.readonly}></PopupDocumento>
    </React.Fragment>
  );
}
